/**
 * Created by vladislav on 9/6/2022
 *
 * https://msstart-games-sdk-doc.azurewebsites.net/tou/
 *
 */

const MSStart = function () {
    Platform.call(this, connector.MSSTART, {
        sdk: SdkManager.SDK_MSSTART
    });

    this.needsCountry = true;
};

MSStart.prototype = Object.create(Platform.prototype);
MSStart.prototype.constructor = MSStart;

MSStart.prototype.getLocalStoragePrefix = function () {
    return "_msstart";
};

MSStart.prototype._parsePayload = function (callback) {
    this.whenConnected(() => {
        const data = $msstart.switchGamePayload || {};
        const params = connector.utils.getRequestParameters();
        let channel = "";

        const ocid = params.ocid || "";

        if (ocid.toLowerCase().startsWith("mspmax_")) {
            channel = ocid;
        }

        channel = channel || params.msstart3pp || data.channel;

        callback({
            channel,
            crossId: data.crossId
        });
    });
};

MSStart.prototype.hasPublisherPlayerId = function () {
    const social = connector.social.getPlugin();
    return Boolean(social && social.publisherPlayerId);
};

MSStart.prototype.switchGame = function (url, data, callback) {
    $msstart.switchGameAsync({
        id: url
    }).then(() => {
        // never happens - changes game on success
    }).catch((e) => {
        callback(e.code === "SWITCH_GAME_DISMISSED" ? ERRORS.SWITCH_GAME.CANCEL : ERRORS.SWITCH_GAME.UNKNOWN);
    });
};

MSStart.prototype.loadData = function () {
    const parseValue = (value) => {
        try {
            const obj = JSON.parse(value);
            if (typeof obj === "object") {
                value = obj;
            }
        } catch (e) { /* empty */ }

        return value;
    };

    return $msstart.cloudSave.getDataAsync({
        gameId: connector.config.projectId
    }).then((data) => {
        for (const key in data) {
            data[key] = parseValue(data[key]);
        }
        return data;
    });
};

MSStart.prototype.setData = function (key, data) {
    return this.setDataBatch({ [key]: data });
};

MSStart.prototype.setDataBatch = function (batch) {
    const toString = (value) => {
        if (value === undefined || value === null) {
            return null;
        }
        return typeof value === "object" ? JSON.stringify(value) : `${value}`;
    };

    for (const key in batch) {
        batch[key] = toString(batch[key]);
    }

    return $msstart.cloudSave.saveDataAsync({
        gameId: connector.config.projectId,
        data: batch
    });
};

MSStart.prototype.getSafePadding = function () {
    return {
        top: 0,
        bottom: 26,
        left: 0,
        right: 0
    };
};

MSStart.prototype.canSwitchGame = function () {
    return true;
};
